module.exports = __webpack_public_path__ + "static/media/badge-id-2.c5cafd8d.png";